import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReferralSection from './TravelAdvisorForm/ReferralSection';

const ClaimThankYou = ({ referralUrl, className = '', htmlId, ctaButtonText, ctaButtonLink }) => {
  const [copied, setCopied] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const shareLink = referralUrl
    ? (referralUrl.startsWith('http') ? referralUrl : `${window.location.origin}${referralUrl}`)
    : '';


  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      ref={containerRef}
      id={htmlId}
      data-testid="ta-registration-form"
      className={`max-w-[1440px] mx-auto px-8 py-12 ${className}`}
    >
      <div className="max-w-[1152px]">
        <h1
          className="text-[48px] font-semibold leading-[62px] text-black mb-4"
          style={{ fontFamily: 'Poppins, sans-serif' }}
          data-testid="ta-thank-you-heading"
        >
          Thank you!
        </h1>
        <p
          className="text-[18px] font-normal leading-[28px] text-black mb-8"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          You are now signed up to be a part of Ship&Play&apos;s travel advisor registry.
        </p>

        <a
          href={ctaButtonLink || '/ship'}
          className="inline-block px-8 py-3 text-white font-semibold text-[16px] leading-[20px]
            bg-[#252525] rounded-2xl hover:bg-[#3a3a3a] mb-10 no-underline"
          style={{ fontFamily: 'Poppins, sans-serif' }}
          data-testid="ta-book-now-button"
        >
          {ctaButtonText || 'Book now'}
        </a>

        {shareLink && (
          <ReferralSection
            referralLink={shareLink}
            copySuccess={copied}
            onCopyLink={handleCopyLink}
          />
        )}
      </div>
    </div>
  );
};

ClaimThankYou.propTypes = {
  referralUrl: PropTypes.string,
  className: PropTypes.string,
  htmlId: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaButtonLink: PropTypes.string
};

export default ClaimThankYou;
